import { useState, useEffect, useMemo } from 'react';
import { getDatabase, ref, onValue } from 'firebase/database';
import { isActiveUser } from '../utils/userStatus';

/**
 * `users` is everyone who is not Inactive: use it for any list or picker.
 * `allUsers` still includes Inactive people, for looking up a name or record
 * by id (an old task's creator, an employee profile being reactivated).
 */
const useUsers = () => {
  const [allUsers, setUsers] = useState([]);
  const users = useMemo(() => allUsers.filter(isActiveUser), [allUsers]);

  useEffect(() => {
    const database = getDatabase();
    const usersRef = ref(database, 'users');

    const unsubscribe = onValue(usersRef, (snapshot) => {
      if (snapshot.exists()) {
        const usersData = snapshot.val();
        const usersList = Object.keys(usersData).map((key) => ({
          id: key,
          ...usersData[key],
        }));
        setUsers(usersList);
      } else {
      }
    }, (error) => {

    });

    return () => unsubscribe();
  }, []);

  const findUserById = (id) => {
    const user = allUsers.find((user) => user.id === id);
    if (user) {
      return {
        name: user.name || `${user.firstName || ''} ${user.lastName || ''}`.trim(),
        firstName: user.firstName || '',
        lastName: user.lastName || '',
        userPhoto: user.userPhoto || user.photoURL || '',
        photoURL: user.photoURL || user.userPhoto || '',
        fullName: user.fullName || '',
        username: user.username || '',
        empID: user.empID || '',
        email: user.email || '',
      };
    }
    return null;
  };

  return { users, allUsers, findUserById };
};

export default useUsers;